import { DisplayPurposeProps } from './display.ts';

export enum ErrorTypeEnum {
  /* CART */
  CartError = 'CART_ERROR',
  CartMaxExceeded = 'CART_MAX',
  CartSave = 'CART_SAVE',
  HoldLost = 'HOLD_LOST',
  // HoldFail = 'HOLD_FAIL',
  InactiveFund = 'INACTIVE_FUND',
  ItemAmountRange = 'ITEM_RANGE',
  ItemExists = 'ITEM_EXISTS',
  ItemUnavaliableFreq = 'ITEM_FREQ',
  ItemMaxExceeded = 'ITEM_MAX',
  BadParameter = 'BAD_PARAMETER',
  // ItemAdd = 'ITEM_ADD',
  // ItemRemove = 'ITEM_REMOVE',
  // ItemUpdate = 'ITEM_UPDATE',
  // InvalidAmount = 'ITEM_AMOUNT',
  /* TRANSACTIONS */
  TransactionError = 'TRANSACTION_ERROR',
  Unknown = 'UNKNOWN',
}

/**
 * Errors
 * Broadly speaking, we are focusing on three fields: `status`, `type`, and
 * `data`, with additional properties when relevant.
 */
export interface ErrorBase {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data?: Record<string, any> | Record<string, any>[];

  /**
   * Identifier field
   *
   * NOTE: This field, at a minimum, is used for the GlobalError `key` identifier
   * so that we can do things like letting the user remove an error and our list
   * will not be ruined
   */
  id?: string;

  /**
   * Intended to convey the severity of the error. Currently assuming it's user-interface related
   * //TODO :: we realize this is crossing over its responsiblity and assuming responsibility
   *  for informing the front-end on how to render. But where else would it be done?
   */
  severity?: DisplayPurposeProps['variants'];

  /**
   * The HTTP status code ([RFC7231], Section 6) generated by the origin
   * server for this occurrence of the problem.
   */
  statusCode?: number;

  /**
   * This is being used as a discriminator to differentiate between
   * error types. This is the field that the front-end should use to switch
   * between and leverage localized messaging
   */
  type: string;

  // TODO :: inherit logger properties
  logArgs?: {
    /**
     * A short, human-readable summary of the problem type. It SHOULD
     * NOT change from occurrence to occurrence of the problem, except
     * for purposes of localization (e.g., using proactive content
     * negotiation; see [RFC7231], Section 3.4).
     */
    title?: string;

    /**
     * A human-readable explanation specific to this occurrence of the
     * problem. NOTE: This is still not intended to be presented to the a web user
     */
    detail?: string;

    /**
     * A human-readable explanation specific to this occurrence of the
     * problem.
     */
    message?: string;

    // TODO :: implement when server-side logging implemented
    // /**
    //  * Log level for this log entry
    //  */
    // logLevel?: LogLevel
  };

  /**
   * Determines if the error should be fixed by the user.
   */
  userShouldFix?: boolean;
}
